import type { Feature } from '@type/features'
import type { JSX } from 'react'

export enum LinkGroupType {
  payable = 'payable',
  receivable = 'receivable',
}

export type LinkGroupOption = {
  label: string
  value: string
  feature?: Feature
}

export type LinkGroupData = {
  getOptions(perms: Set<string>): LinkGroupOption[]
  isActive(path: string): boolean
  type: LinkGroupType
  feature?: Feature
}

export type SingleLinkObject = {
  to: string
  label: string | JSX.Element
  isActive: (path: string) => boolean
  feature?: Feature
}
